const NEW_SERVICES_CHAT_FOOTER_TEXT = "Conversation will be automatically updated if any people are added or removed from a team.";

export { NEW_SERVICES_CHAT_FOOTER_TEXT };
//# sourceMappingURL=constants.js.map
